// extracted by mini-css-extract-plugin
export default {"specialPriceRow":"specialPriceRow__WkCzF","priceOld":"priceOld__OaHdA","priceNew":"priceNew__0w-AR"};